import { CANONICAL_SITE_URL } from '@/constants/metadata';

import { BreadcrumbItem, BreadcrumbSegment } from './types';

const ROOT_SEGMENT: BreadcrumbSegment = { label: 'Qream', href: '/' };

const toAbsoluteUrl = (href: string): string => {
	if (href.startsWith('http')) return href;

	const base = CANONICAL_SITE_URL.replace(/\/$/, '');
	if (href === '/') return base;

	return `${base}${href.startsWith('/') ? href : `/${href}`}`;
};

export const buildBreadcrumbs = (segments: BreadcrumbSegment[]): BreadcrumbItem[] => {
	const items: BreadcrumbItem[] = [
		{
			label: ROOT_SEGMENT.label,
			href: ROOT_SEGMENT.href
		}
	];

	segments.forEach((segment, index) => {
		const isLast = index === segments.length - 1;

		items.push({
			label: segment.label,
			href: isLast ? undefined : segment.href,
			...(segment.truncate ? { truncate: true } : {})
		});
	});

	return items;
};

export const buildBreadcrumbListJsonLd = (items: BreadcrumbItem[]) => ({
	'@context': 'https://schema.org',
	'@type': 'BreadcrumbList',
	itemListElement: items.map((item, index) => {
		const isLast = index === items.length - 1;
		const entry: Record<string, unknown> = {
			'@type': 'ListItem',
			position: index + 1,
			name: item.label
		};

		if (!isLast && item.href) entry.item = toAbsoluteUrl(item.href);

		return entry;
	})
});
